import React, { useEffect, useState } from "react";

const OtpTimer = ({ initialTime = 30, onTimerComplete }) => {
    const [timer, setTimer] = useState(initialTime);

    useEffect(() => {
        let interval = null;
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prevTime) => prevTime - 1);
            }, 1000);
        } else {
            if (onTimerComplete) onTimerComplete();
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [timer, onTimerComplete]);

    return timer > 0 ? <span>{`${timer}s`}</span> : null;
};

export default React.memo(OtpTimer);
